import { render, staticRenderFns } from "./StatReport_new.vue?vue&type=template&id=2fda5c9e"
import script from "./StatReport_new.vue?vue&type=script&lang=js"
export * from "./StatReport_new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports